import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  businessCategoryList: []
};

export default function businessCategoryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOAD_BUSINESS_CATEGORY:
    case actionTypes.LOAD_BUSINESS_CATEGORY_FAIL: {
      return {
        ...state,
        businessCategoryList: INITIAL_STATE.businessCategoryList
      };
    }
    case actionTypes.LOAD_BUSINESS_CATEGORY_SUCCESS: {
      return {
        ...state,
        businessCategoryList: action.data
      };
    }
    default:
      return state;
  }
}
